export default function ServiceMechanical({ size = 96 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" aria-hidden="true">
      <circle cx="48" cy="48" r="22" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="48" cy="48" r="6" stroke="currentColor" strokeWidth="1.25" />
      <path
        d="M48 18 V32 M48 64 V78 M18 48 H32 M64 48 H78 M27 27 L37 37 M59 59 L69 69 M27 69 L37 59 M59 37 L69 27"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path d="M84 12 H88 V16" stroke="#54B53C" strokeWidth="1.25" />
    </svg>
  );
}
